/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class HistoryStudiesService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.HISTORY_STUDIES_LISTALL_PAGINATION, params);
  }
  static downloadReport(params) {
    return this.postPDFSEC(ServiceConstant.HISTORY_STUDIES_DOWNLOAD_REPORT, params);
  }
}
